/**
 * Opciones de trimestres para el filtro
 */
export const QUARTER_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 1, label: '1 (Ene, Feb, Mar)' },
  { value: 2, label: '2 (Abr, May, Jun)' },
  { value: 3, label: '3 (Jul, Ago, Sep)' },
  { value: 4, label: '4 (Oct, Nov, Dic)' },
];

/**
 * Año inicial para el selector de años
 */
export const START_YEAR = 1990;

/**
 * Estilos para los chips de órdenes no generadas
 */
export const CHIP_STYLES = {
  minWidth: '40px',
  backgroundColor: '#fedede',
  border: '1px solid #d44242',
  color: '#3a5431',
  fontWeight: 'medium',
  margin: '1px',
  '&:hover': {
    backgroundColor: '#ff9494',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    cursor: 'pointer',
  },
};
